import React from 'react'
import './sectionContent.scss'

const SectionContent = ({ className, sectionId = '', children }) => {
	return (
		<div id={sectionId} className={`section_content ${className}`}>
			{children}
		</div>
	)
}

export default SectionContent
